import { Name } from "./Components/Name/Name.jsx";
import { Details } from "./Components/Details/Details.jsx";
import { Bio } from "./Components/Bio/Bio.jsx";
import { Projects } from "./Components/Projects/Projects";
import {Skills} from "./Components/Skills/Skills";
import { Contacts } from "./Components/Contact/Contact.jsx";
import "./App.css";
import './Components/Details/Details.css'
import './Components/Name/Name.css'
import './Components/Bio/Bio.css'
import './Components/Projects/Projects.css'
import './Components/Skills/Skills.css'
import './Components/Contact/Contact.css'
function App() {
	return (
		<div className="App">
	
			
			<header className="App-header">
				<Details />
			</header>
			<Name />
		

			<main>
				<section>
					<Bio />
				</section>
				
				<section>
					<Skills />
				</section>
				
				<section>
					<Projects />
				</section>
			</main>
			
			<Contacts/>
			</div>
	);
}

export default App;
